import { __decorate } from "tslib";
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
let SVGIcon = class SVGIcon extends LitElement {
    connectedCallback() {
        var _a;
        (_a = super.connectedCallback) === null || _a === void 0 ? void 0 : _a.call(this);
    }
    static get styles() {
        return css `
			:host {
				width: 24px;
				height: 24px;
				display: inline-block;
			}
			.Sidebar__itemIcon {
				fill: #a5a4a2;
				height: 24px;
				margin: 0 3px;
				overflow: visible;
				width: 24px;
			}
			.Sidebar__itemIcon--active {
				fill: #077cab;
			}
		`;
    }
    render() {
        return html `
			<svg class="${this.iconClass}">
				<use
					href="/static/icons.svg#${this.iconName}"
					xlink:href="/static/icons.svg#${this.iconName}"
				/>
			</svg>
		`;
    }
};
__decorate([
    property({ type: String })
], SVGIcon.prototype, "iconName", void 0);
__decorate([
    property({ type: String })
], SVGIcon.prototype, "iconClass", void 0);
SVGIcon = __decorate([
    customElement('svg-icon')
], SVGIcon);
export { SVGIcon };
//# sourceMappingURL=svgIcons.js.map